import React, { Component } from 'react';
import {
  Row,
  Col,
  Card,
  CardHeader,
  CardBody,
  CardFooter,
  CardGroup, Table,
  Progress,
  Collapse, Button, Fade, Jumbotron,
  ListGroup, ListGroupItem, ListGroupItemHeading, ListGroupItemText,
  Input,
  InputGroup,
  FormGroup,
  InputGroupAddon,
  InputGroupText,
  Form,
  Pagination,
  PaginationItem,
  PaginationLink
} from 'reactstrap';
import moment from 'moment';
import { Link } from "react-router-dom";
import { makeInput, Loading } from "common-import/custom";
import { inject, observer } from "mobx-react";

import { TimeHelper, VarHelper } from "common-import/helpers"

const StatusList = {
  'all': 'All',
  'approved': 'Approved',
  'not-approved': 'Not Approved',
  'not-approved-update': 'Not Approved (update)',
};

@inject("projectStore", "userStore", "masterStore", "routeStore") @observer
class ProjectList extends Component {

  constructor(props) {
    super(props);
    this.state = {
      isLoading: true,
      keyword: "",
      page: 1,
      status: 'all',
      list: [],
    }
  }

  async componentDidMount() {
    await this.props.userStore.onReady();
    await this.getList();
    this.setState({isLoading: false})
  }

  renderRow = (data, index) => {
    const { routeStore } = this.props;
    const {toValue, project_type} = this.props.masterStore;

    return (
      <tr key={"row"+index}>
        <td>
          <Link to={routeStore.admin.projectDetail(data.id, data.name)}>
            <div><strong>{data.name}</strong></div>
          </Link>
        </td>
        <td>
          <div className="clearfix">
            <div className="float-left">{toValue(project_type, data.type)}</div>
          </div>
        </td>
        <td>
          <a >
            <div>{data.city}</div>
            <div className="small text-muted">
              <span>District</span>: {data.district}
            </div>
            <div className="small text-muted">
              <span>Address</span>: {data.address}
            </div>
            {/* <div className="small text-muted">
              <span>Fax</span>: {data.fax}
            </div> */}
          </a>
        </td>
        <td>
          <div className="small text-muted">{data.status}</div>
        </td>
        <td>
          <div className="small text-muted"><strong>Start:</strong> {moment(data.minStartTime).format('LL')}</div>
          <div className="small text-muted"><strong>End:</strong> {moment(data.maxFinishTime).format('LL')}</div>
        </td>
      </tr>

    )
  };

  render() {
    let { isLoading, list } = this.state;
    list = list.slice();
    if (isLoading) return (<Loading> </Loading>);
    return (
      <div className="animated fadeIn">
        <Form onSubmit={this.search}>
          <FormGroup>
            <Button type="button" color="primary" onClick={this.search} className="mb-8"><i className="fa fa-search"> </i> Search</Button>
            {makeInput(this, "keyword")(<Input type="text" id="input1-group2" name="input1-group2" placeholder="Project's name" />)}
          </FormGroup>
        </Form>
        <div className="form">
          <div className="form-group" style={{width:'200px'}}>
            <select value={this.state.status} className="form-control" onChange={(e) => this.setState({status: e.target.value, page: 1}, () => this.getList())}>
              {
                Object.entries(StatusList).map(([key, value]) => {
                  return <option key={key} value={key}>{value}</option>
                })
              }
            </select>
          </div>
        </div>
        <Row>
          <Col xs="12" sm="12">
            <Table hover responsive className="table-outline mb-0 d-sm-table">
              <thead className="thead-light">
              <tr>
                <th>Project Name</th>
                <th>Type</th>
                <th>Address</th>
                <th>Status</th>
                <th>Duration</th>
              </tr>
              </thead>
              <tbody style={{backgroundColor: 'white'}}>
              {list.length > 0 && list.map((val, index) => this.renderRow({
                id: val.id,
                name: val.name,
                type: val.projectType,
                budget: val.maxBuget,
                status: val.status,
                address: val.address,
                district: val.district,
                city: val.city,
                minStartTime: val.minStartTime,
                maxFinishTime: val.maxFinishTime
              }, index))}
              </tbody>
            </Table>
            {list.length === 0 && <p style={{ marginTop: 20, testAlign: "center", display: "block" }}>Data Empty</p>}
          </Col>
        </Row>
        <Row style={{marginTop: 20, marginBottom: 20}}>
          <Col xs="12" md="12">
            <Pagination>
              <PaginationItem>
                <PaginationLink previous onClick={this.loadPrev}/>
              </PaginationItem>
              <PaginationItem>
                <PaginationLink>{this.state.page}</PaginationLink>
              </PaginationItem>
              <PaginationItem>
                <PaginationLink next onClick={this.loadNext} />
              </PaginationItem>
            </Pagination>
          </Col>
        </Row>
      </div>
    );
  }

  search = e => {
    !!e && e.preventDefault();
    const { projectStore } = this.props;
    const { keyword } = this.state;
    if (keyword === "") {
      projectStore.getListApproved();
    } else {
      projectStore.search(keyword, true);
    }
  };

  loadPrev = e => {
    !!e && e.preventDefault();
    if (this.state.page === 1) return;
    this.setState({ page: this.state.page - 1}, () => {
      this.getList();
    });
  };

  loadNext = e => {
    !!e && e.preventDefault();
    this.setState({ page: this.state.page + 1}, () => {
      this.getList();
    });
  };

  getList = async () => {
    const { status } = this.state;
    const { projectStore } = this.props;
    switch (status) {
      case 'all': {
        await projectStore.getAll(this.state.page);
        this.setState({list: projectStore.listApproved});
        break;
      }
      case 'approved': {
        await projectStore.getListApproved(this.state.page);
        this.setState({list: projectStore.listApproved});
        break;
      }
      case 'not-approved': {
        await projectStore.getListNotApproved(this.state.page);
        this.setState({list: projectStore.listNotApproved});
        break;
      }
      case 'not-approved-update': {
        await projectStore.getListNotApprovedUpdate(this.state.page);
        this.setState({list: projectStore.listNotApproved});
        break;
      }
    }
  };
}

export default ProjectList;



// WEBPACK FOOTER //
// ./src/views/Projects/List.js